import React from "react";
import SaasProductWizard from "../index";

function NextcloudWizard() {
  return <SaasProductWizard productType="nextcloud" />;
}

export default NextcloudWizard;